<template>
  <div class="widget-inner">
    <div class="top py-3">
      <strong>Řízení elektrické energie</strong>
    </div>
    <div class="bottom">
      <div id="energy-widget"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

const DEVICE_TYPES = {
  1: {
    text: 'Dům',
    detail: '',
    icon: 'Home',
    line: 'in',
  },
  2: {
    text: 'Síť',
    detail: '',
    icon: 'NetSource',
    line: 'in',
  },
  3: {
    text: 'Fotovoltaika',
    detail: '',
    icon: 'Solar',
    line: 'in',
  },
  4: {
    text: 'Světla',
    detail: '',
    icon: 'Lights',
    line: 'out',
  },
  5: {
    text: 'Klimatizace',
    detail: '',
    icon: 'Air condition',
    line: 'out',
  },
  6: {
    text: 'Auta',
    detail: '',
    icon: 'Car',
    line: 'out',
  },
  7: {
    text: 'Topné patrony v akumulačním zásobníku',
    detail: '',
    icon: 'Heat',
    line: 'out',
  },
  8: {
    text: 'Baterie',
    detail: '',
    icon: 'Battery',
    line: 'in',
  },
};

const DEVICE_ICONS = [
  {
    name: 'NetSource',
    svg: 'M20.784,29.91c0.092,0.057 0.2,0.09 0.313,0.09c0.044,-0 0.089,-0.005 0.134,-0.015c0.322,-0.074 0.523,-0.394 0.449,-0.716l-3.321,-14.503l4.755,-0l-0,0.159l-0.216,0c-0.33,0 -0.597,0.268 -0.597,0.598c-0,0.33 0.267,0.597 0.597,0.597l0.216,0l-0,0.199l-0.216,-0c-0.33,-0 -0.597,0.267 -0.597,0.597c-0,0.33 0.267,0.598 0.597,0.598l0.216,0l-0,0.215c-0,0.33 0.267,0.598 0.597,0.598c0.33,0 0.598,-0.268 0.598,-0.598l-0,-0.215l0.215,0c0.33,0 0.598,-0.268 0.598,-0.598c-0,-0.33 -0.268,-0.597 -0.598,-0.597l-0.215,-0l-0,-0.199l0.215,0c0.33,0 0.598,-0.267 0.598,-0.597c-0,-0.33 -0.268,-0.598 -0.598,-0.598l-0.215,0l-0,-0.738c-0,-0.003 -0.001,-0.006 -0.001,-0.01c0.004,-0.22 -0.115,-0.43 -0.317,-0.537l-5.78,-3.065l-0,-2.295l4.903,0l-0,0.199l-0.216,-0c-0.33,-0 -0.597,0.267 -0.597,0.597c-0,0.33 0.267,0.598 0.597,0.598l0.216,0l-0,0.199l-0.216,-0c-0.33,-0 -0.597,0.267 -0.597,0.597c-0,0.33 0.267,0.598 0.597,0.598l0.216,-0l-0,0.215c-0,0.33 0.267,0.598 0.597,0.598c0.33,-0 0.598,-0.268 0.598,-0.598l-0,-0.215l0.215,-0c0.33,-0 0.598,-0.268 0.598,-0.598c-0,-0.33 -0.268,-0.597 -0.598,-0.597l-0.215,-0l-0,-0.199l0.215,0c0.33,0 0.598,-0.268 0.598,-0.598c-0,-0.33 -0.268,-0.597 -0.598,-0.597l-0.215,-0l-0,-0.738c-0,-0.009 -0.001,-0.017 -0.001,-0.025c0.012,-0.229 -0.108,-0.451 -0.317,-0.561l-3.75,-1.989c-0.292,-0.154 -0.654,-0.043 -0.808,0.248c-0.155,0.292 -0.044,0.654 0.248,0.808l1.627,0.863l-3.097,0l-0,-2.636c-0,-0.003 -0.001,-0.006 -0.001,-0.01c-0.002,-0.114 -0.036,-0.227 -0.102,-0.325l-2.614,-3.852c-0.111,-0.164 -0.296,-0.262 -0.494,-0.262c-0.198,0 -0.383,0.098 -0.495,0.262l-2.529,3.729l-5.967,3.164c-0.209,0.11 -0.329,0.331 -0.316,0.561c-0.001,0.008 -0.002,0.016 -0.002,0.025l0,0.738l-0.215,-0c-0.33,-0 -0.598,0.267 -0.598,0.597c0,0.33 0.268,0.598 0.598,0.598l0.215,-0l0,0.198l-0.215,0c-0.33,0 -0.598,0.268 -0.598,0.598c0,0.33 0.268,0.598 0.598,0.598l0.215,-0l0,0.215c0,0.33 0.268,0.598 0.598,0.598c0.33,-0 0.597,-0.268 0.597,-0.598l0,-0.215l0.216,-0c0.33,-0 0.597,-0.268 0.597,-0.598c0,-0.33 -0.267,-0.598 -0.597,-0.598l-0.216,0l0,-0.198l0.216,-0c0.33,-0 0.597,-0.268 0.597,-0.598c0,-0.33 -0.267,-0.597 -0.597,-0.597l-0.216,-0l0,-0.199l4.903,0l0,2.295l-5.78,3.065c-0.202,0.107 -0.321,0.317 -0.317,0.537c-0,0.004 -0.001,0.007 -0.001,0.01l0,0.738l-0.215,0c-0.33,0 -0.598,0.268 -0.598,0.598c0,0.33 0.268,0.597 0.598,0.597l0.215,0l0,0.199l-0.215,-0c-0.33,-0 -0.598,0.267 -0.598,0.597c0,0.33 0.268,0.598 0.598,0.598l0.215,-0l0,0.215c0,0.33 0.268,0.598 0.598,0.598c0.33,-0 0.597,-0.268 0.597,-0.598l0,-0.215l0.216,-0c0.33,-0 0.597,-0.268 0.597,-0.598c0,-0.33 -0.267,-0.597 -0.597,-0.597l-0.216,-0l0,-0.199l0.216,0c0.33,0 0.597,-0.267 0.597,-0.597c0,-0.33 -0.267,-0.598 -0.597,-0.598l-0.216,0l0,-0.16l4.755,0l-3.321,14.504c-0.074,0.322 0.127,0.642 0.449,0.716c0.05,0.011 0.099,0.015 0.148,0.014c0.005,0 0.009,0.001 0.014,0.001c0.153,-0 0.306,-0.059 0.423,-0.175l5.923,-5.923l3.948,0l0.844,3.686l-1.36,-1.36c-0.233,-0.233 -0.611,-0.233 -0.845,0c-0.233,0.234 -0.233,0.612 0,0.846l2.775,2.71l0.145,0.126Zm-10.844,-2.362l0.835,-3.646l2.811,0l-3.646,3.646Zm7.16,-2.989c-0.233,-0.234 -0.611,-0.236 -0.846,-0.003c-0.234,0.232 -0.235,0.611 -0.003,0.845l0.297,0.299c0.117,0.117 0.27,0.176 0.424,0.176c0.152,0 0.305,-0.057 0.421,-0.173c0.234,-0.233 0.236,-0.611 0.003,-0.845l-0.296,-0.299Zm-0.628,-1.852l2.017,-2.018l0.462,2.018l-2.479,-0Zm-4.956,-2.041l1.271,1.271c0.117,0.116 0.269,0.175 0.422,0.175c0.153,-0 0.306,-0.059 0.423,-0.175c0.233,-0.234 0.233,-0.612 -0,-0.846l-1.521,-1.521l1.851,-1.541c0.254,-0.211 0.288,-0.588 0.077,-0.842c-0.211,-0.253 -0.588,-0.288 -0.842,-0.077l-1.071,0.892l0.621,-2.712l5.158,4.293l-3.124,3.124l-3.732,-0l0.467,-2.041Zm2.492,-5.881l3.129,-0l0.737,3.217l-3.866,-3.217Zm-2.219,-2.857l0,1.642l-3.097,0l3.097,-1.642Zm1.195,1.642l0,-2.038l4.032,0l-0,2.038l-4.032,0Zm5.227,0l-0,-1.642l3.097,1.642l-3.097,0Zm-1.195,-3.233l-4.032,0l0,-2.038l4.032,0l-0,2.038Zm-4.032,-3.252l0,-2.038l4.032,0l-0,2.038l-4.032,0Zm-1.195,-1.642l0,1.642l-3.097,0l3.097,-1.642Zm3.211,-3.781l1.486,2.19l-2.972,-0l1.486,-2.19Z'
  },
  {
    name: 'Solar',
    svg: 'M29.915,28.965l-2.583,-4.33c-0.169,-0.283 -0.536,-0.376 -0.82,-0.207c-0.283,0.169 -0.376,0.536 -0.207,0.82l2.584,4.33c0.112,0.187 0.31,0.291 0.514,0.291c0.104,0 0.21,-0.027 0.306,-0.084c0.283,-0.169 0.376,-0.536 0.206,-0.82Zm-2.481,-11.328c-0.113,-0.15 -0.29,-0.238 -0.478,-0.238l-19.41,0c-0.267,0 -0.501,0.177 -0.574,0.433l-3.227,11.275c-0.051,0.181 -0.015,0.375 0.097,0.524c0.113,0.15 0.29,0.238 0.478,0.238l19.41,0c0.267,0 0.501,-0.176 0.575,-0.433l3.226,-11.275c0.052,-0.18 0.016,-0.374 -0.097,-0.524Zm-16.077,11.037l0.725,-2.534l4.016,-0c0.33,-0 0.598,-0.268 0.598,-0.598c-0,-0.33 -0.268,-0.597 -0.598,-0.597l-3.674,-0l1.817,-6.351l5.21,0l-0.7,2.448l-4.096,-0c-0.33,-0 -0.598,0.267 -0.598,0.597c0,0.33 0.268,0.598 0.598,0.598l3.754,-0l-1.842,6.437l-5.21,0Zm12.99,-3.729l-4.295,-0c-0.33,-0 -0.598,0.267 -0.598,0.597c0,0.33 0.268,0.598 0.598,0.598l3.953,-0l-0.725,2.534l-5.47,0l1.842,-6.437l5.47,-0l-0.775,2.708Zm-14.233,3.729l-5.002,0l0.725,-2.534l5.002,-0l-0.725,2.534Zm-3.935,-3.729l0.775,-2.708l3.873,-0c0.33,-0 0.597,-0.268 0.597,-0.598c0,-0.33 -0.267,-0.597 -0.597,-0.597l-3.531,-0l0.701,-2.448l5.001,0l-1.817,6.351l-5.002,-0Zm19.285,-3.903l-5.47,-0l0.7,-2.448l5.47,0l-0.7,2.448Zm-19.803,-8.072l-0,0.801c-0,0.33 0.267,0.598 0.597,0.598c0.33,-0 0.598,-0.268 0.598,-0.598l-0,-0.801c-0,-0.33 -0.268,-0.598 -0.598,-0.598c-0.33,-0 -0.597,0.268 -0.597,0.598Zm-4.67,-0.508l-0.089,0.088c-0.233,0.234 -0.233,0.612 0,0.846c0.117,0.116 0.27,0.175 0.423,0.175c0.153,-0 0.306,-0.059 0.422,-0.175l0.089,-0.089c0.233,-0.233 0.233,-0.612 -0,-0.845c-0.233,-0.234 -0.612,-0.234 -0.845,-0Zm9.176,-1.318c-0.234,-0.233 -0.612,-0.233 -0.845,0c-0.234,0.234 -0.234,0.612 -0,0.846l0.566,0.566c0.117,0.117 0.27,0.175 0.423,0.175c0.153,0 0.306,-0.058 0.423,-0.175c0.233,-0.233 0.233,-0.611 -0,-0.845l-0.567,-0.567Zm-7.788,-0.07l-0.267,0.266c-0.233,0.234 -0.233,0.612 0,0.846c0.117,0.116 0.27,0.175 0.423,0.175c0.153,-0 0.306,-0.059 0.423,-0.175l0.266,-0.267c0.234,-0.234 0.234,-0.612 0,-0.845c-0.233,-0.234 -0.612,-0.234 -0.845,-0Zm3.929,0.451c1.911,-0 3.465,-1.554 3.465,-3.465c-0,-1.91 -1.554,-3.464 -3.465,-3.464c-1.91,-0 -3.464,1.554 -3.464,3.464c-0,1.911 1.554,3.465 3.464,3.465Zm0,-5.734c1.252,-0 2.27,1.018 2.27,2.269c-0,1.252 -1.018,2.27 -2.27,2.27c-1.251,-0 -2.269,-1.018 -2.269,-2.27c-0,-1.251 1.018,-2.269 2.269,-2.269Zm4.312,2.319c-0,0.33 0.268,0.598 0.598,0.598l0.801,0c0.33,0 0.598,-0.268 0.598,-0.598c-0,-0.33 -0.268,-0.597 -0.598,-0.597l-0.801,-0c-0.33,-0 -0.598,0.267 -0.598,0.597Zm-8.623,-0.1c-0,-0.33 -0.268,-0.597 -0.598,-0.597l-0.801,-0c-0.33,-0 -0.598,0.267 -0.598,0.597c0,0.33 0.268,0.598 0.598,0.598l0.801,-0c0.33,-0 0.598,-0.268 0.598,-0.598Zm7.818,-2.788c0.153,0 0.306,-0.058 0.423,-0.175l0.266,-0.267c0.234,-0.233 0.234,-0.611 0,-0.845c-0.233,-0.233 -0.612,-0.233 -0.845,0l-0.266,0.267c-0.234,0.233 -0.234,0.612 -0,0.845c0.116,0.117 0.269,0.175 0.422,0.175Zm-7.365,-0.246c0.117,0.117 0.27,0.175 0.422,0.175c0.153,0 0.306,-0.058 0.423,-0.175c0.233,-0.233 0.233,-0.612 0,-0.845l-0.567,-0.567c-0.233,-0.233 -0.612,-0.233 -0.845,0c-0.233,0.234 -0.233,0.612 0,0.845l0.567,0.567Zm8.761,-1.15c0.153,-0 0.306,-0.059 0.423,-0.175l0.112,-0.112c0.233,-0.234 0.233,-0.612 -0,-0.845c-0.234,-0.234 -0.612,-0.234 -0.845,-0l-0.112,0.112c-0.234,0.233 -0.234,0.611 -0,0.845c0.116,0.116 0.269,0.175 0.422,0.175Zm-4.853,-0.077c0.33,-0 0.598,-0.268 0.598,-0.598l0,-0.801c0,-0.33 -0.268,-0.598 -0.598,-0.598c-0.33,0 -0.597,0.268 -0.597,0.598l-0,0.801c-0,0.33 0.267,0.598 0.597,0.598Z'
  },
  {
    name: 'Air condition',
    svg: 'M20.75,23.426c-0.5,-0.25 -0.75,-0.55 -0.75,-0.8c0,-0.25 0.3,-0.55 0.7,-0.85c0.25,-0.1 0.3,-0.4 0.2,-0.65c-0.1,-0.25 -0.4,-0.35 -0.65,-0.2c-0.8,0.45 -1.25,1.05 -1.25,1.7c0,0.65 0.45,1.25 1.25,1.75c0.5,0.25 0.75,0.55 0.75,0.8c0,0.25 -0.3,0.55 -0.75,0.8c-0.25,0.1 -0.35,0.4 -0.2,0.65c0.1,0.15 0.25,0.25 0.45,0.25c0.1,0 0.15,0 0.25,-0.05c0.8,-0.45 1.25,-1.05 1.25,-1.7c0,-0.65 -0.45,-1.3 -1.25,-1.7Zm-11,-0c-0.5,-0.25 -0.75,-0.55 -0.75,-0.8c0,-0.25 0.3,-0.55 0.7,-0.85c0.25,-0.1 0.35,-0.4 0.2,-0.65c-0.1,-0.25 -0.4,-0.35 -0.65,-0.2c-0.8,0.45 -1.25,1.05 -1.25,1.7c0,0.65 0.45,1.25 1.25,1.75c0.5,0.25 0.75,0.55 0.75,0.8c0,0.25 -0.3,0.55 -0.75,0.8c-0.25,0.1 -0.35,0.4 -0.2,0.65c0.1,0.15 0.25,0.25 0.45,0.25c0.1,0 0.15,0 0.25,-0.05c0.8,-0.45 1.25,-1.05 1.25,-1.7c0,-0.65 -0.45,-1.3 -1.25,-1.7Zm5.5,-1c-0.5,-0.25 -0.75,-0.55 -0.75,-0.8c0,-0.25 0.3,-0.55 0.7,-0.85c0.25,-0.1 0.3,-0.4 0.2,-0.65c-0.1,-0.25 -0.4,-0.35 -0.65,-0.2c-0.8,0.45 -1.25,1.05 -1.25,1.7c0,0.65 0.45,1.25 1.25,1.75c0.5,0.25 0.75,0.55 0.75,0.8c0,0.25 -0.3,0.55 -0.75,0.8c-0.25,0.1 -0.35,0.4 -0.2,0.65c0.1,0.15 0.25,0.25 0.45,0.25c0.1,-0 0.15,-0 0.25,-0.05c0.8,-0.45 1.25,-1.05 1.25,-1.7c0,-0.65 -0.45,-1.3 -1.25,-1.7Zm13.25,-16.55l-27,-0c-0.85,-0 -1.5,0.65 -1.5,1.5l0,10c0,0.85 0.65,1.5 1.5,1.5l27,-0c0.85,-0 1.5,-0.65 1.5,-1.5l-0,-10c0,-0.85 -0.65,-1.5 -1.5,-1.5Zm0.5,11.5c0,0.3 -0.2,0.5 -0.5,0.5l-27,-0c-0.3,-0 -0.5,-0.2 -0.5,-0.5l0,-10c0,-0.3 0.25,-0.5 0.5,-0.5l27,-0c0.3,-0 0.5,0.2 0.5,0.5l-0,10l0,-0Zm-1.5,-1.5l-25,-0c-0.3,-0 -0.5,0.2 -0.5,0.5c0,0.3 0.2,0.5 0.5,0.5l25,-0c0.3,-0 0.5,-0.2 0.5,-0.5c-0,-0.3 -0.2,-0.5 -0.5,-0.5Zm0,-2l-25,-0c-0.3,-0 -0.5,0.2 -0.5,0.5c0,0.3 0.2,0.5 0.5,0.5l25,-0c0.3,-0 0.5,-0.2 0.5,-0.5c-0,-0.3 -0.2,-0.5 -0.5,-0.5Zm-14.5,-3.5l4,-0c0.3,-0 0.5,-0.2 0.5,-0.5c-0,-0.3 -0.2,-0.5 -0.5,-0.5l-4,0c-0.3,0 -0.5,0.2 -0.5,0.5c0,0.3 0.2,0.5 0.5,0.5Z'
  },
  {
    name: 'Lights',
    svg: 'M15,7.524c-3.786,-0 -6.52,2.821 -6.954,5.852c-0.27,2.02 0.383,3.99 1.74,5.48c1.194,1.275 1.847,2.979 1.847,4.734l-0.005,2.766c-0,1.117 0.923,2.02 2.066,2.02l2.663,-0c1.143,-0 2.066,-0.903 2.066,-2.02l0.006,-2.766c-0,-1.806 0.597,-3.459 1.739,-4.627c1.25,-1.276 1.903,-2.924 1.903,-4.628c-0.005,-3.78 -3.214,-6.811 -7.071,-6.811Zm2.388,18.832c-0,0.53 -0.434,0.959 -0.98,0.959l-2.663,-0c-0.546,-0 -0.98,-0.424 -0.98,-0.959l0,-1.225l4.618,0l-0,1.225l0.005,-0Zm2.02,-8.138c-1.357,1.382 -2.066,3.296 -2.066,5.372l-0,0.48l-4.618,-0l0,-0.48c0,-1.969 -0.816,-3.933 -2.173,-5.423c-1.194,-1.276 -1.684,-2.924 -1.469,-4.628c0.382,-2.551 2.755,-4.949 5.923,-4.949c3.316,0 5.98,2.607 5.98,5.745c-0,1.434 -0.546,2.817 -1.577,3.883Zm8.092,-3.352l-2.663,-0l-0,1.066l2.663,0l0,-1.066Zm-22.337,-0l-2.663,-0l0,1.066l2.663,0l0,-1.066Zm16.424,-6.572l0.76,0.761l1.862,-1.791l-0.765,-0.76l-1.857,1.79Zm-15.051,-1.796l-0.766,0.761l1.863,1.79l0.76,-0.76l-1.857,-1.791Zm9.005,-3.122l-1.087,0l0,2.551l1.087,0l-0,-2.551Z'
  },
  {
    name: 'Car',
    svg: 'M26.666,13.675l-4.36,-0.498l-2.327,-3.783c-0.711,-1.155 -1.995,-1.873 -3.351,-1.873l-7.917,0c-2.276,0 -4.287,1.533 -4.892,3.727l-0.061,0.225c-0.301,1.09 -1.163,1.958 -2.252,2.265c-0.887,0.25 -1.506,1.068 -1.506,1.99l-0,5.409c-0,0.27 0.219,0.489 0.489,0.489l2.512,-0c0.31,1.485 1.63,2.605 3.206,2.605c1.576,-0 2.896,-1.12 3.206,-2.605l10.645,-0c0.31,1.485 1.63,2.605 3.206,2.605c1.576,-0 2.896,-1.12 3.206,-2.605l2.637,-0c0.249,-0 0.458,-0.187 0.486,-0.434l0.383,-3.355c0.234,-2.059 -1.25,-3.926 -3.31,-4.162Zm-20.459,9.578c-1.267,0 -2.297,-1.03 -2.297,-2.297c-0,-1.267 1.03,-2.297 2.297,-2.297c1.267,-0 2.297,1.03 2.297,2.297c0,1.267 -1.03,2.297 -2.297,2.297Zm17.057,0c-1.267,0 -2.297,-1.03 -2.297,-2.297c-0,-1.267 1.03,-2.297 2.297,-2.297c1.267,-0 2.297,1.03 2.297,2.297c0,1.267 -1.03,2.297 -2.297,2.297Zm-17.057,-3.929c-0.9,0 -1.632,0.732 -1.632,1.632c0,0.9 0.732,1.632 1.632,1.632c0.9,-0 1.632,-0.732 1.632,-1.632c-0,-0.9 -0.732,-1.632 -1.632,-1.632Zm17.057,0c-0.9,0 -1.632,0.732 -1.632,1.632c0,0.9 0.732,1.632 1.632,1.632c0.9,-0 1.631,-0.732 1.631,-1.632c0,-0.9 -0.731,-1.632 -1.631,-1.632Zm-17.057,2.286c-0.361,0 -0.654,-0.293 -0.654,-0.654c-0,-0.361 0.293,-0.654 0.654,-0.654c0.361,-0 0.654,0.293 0.654,0.654c0,0.361 -0.293,0.654 -0.654,0.654Zm17.057,0c-0.361,0 -0.654,-0.293 -0.654,-0.654c-0,-0.361 0.293,-0.654 0.654,-0.654c0.361,-0 0.654,0.293 0.654,0.654c0,0.361 -0.293,0.654 -0.654,0.654Zm-22.287,-1.556l2.082,0c-0.055,0.192 -0.093,0.39 -0.112,0.594l-1.97,0l0,-0.594Zm22.287,-2.373c-1.107,0 -2.087,0.553 -2.68,1.396l-8.697,-0c-0.27,-0 -0.488,0.219 -0.488,0.489c-0,0.27 0.218,0.488 0.488,0.488l8.229,0c-0.055,0.192 -0.093,0.39 -0.112,0.594l-10.537,0c-0.156,-1.662 -1.558,-2.967 -3.26,-2.967c-1.107,0 -2.087,0.553 -2.68,1.396l-2.55,-0l0,-3.349c0,-0.486 0.327,-0.918 0.795,-1.049c1.415,-0.4 2.537,-1.529 2.928,-2.947l0.062,-0.224c0.487,-1.772 2.111,-3.009 3.949,-3.009l7.917,-0c1.019,-0 1.984,0.539 2.518,1.407l2.452,3.986c0.079,0.128 0.212,0.212 0.361,0.229l4.596,0.526c1.043,0.119 1.886,0.803 2.26,1.712l-1.526,-0c-0.27,-0 -0.489,0.219 -0.489,0.488c0,0.27 0.219,0.489 0.489,0.489l1.732,0c0.003,0.129 -0.002,0.259 -0.017,0.391l-0.154,1.35l-2.907,-0c-0.593,-0.843 -1.572,-1.396 -2.679,-1.396Zm3.26,2.967c-0.019,-0.204 -0.058,-0.402 -0.113,-0.594l2.328,0l-0.068,0.594l-2.147,0Zm-15.826,-1.263c-0.001,-0.003 -0.004,-0.01 -0.005,-0.013c-0.088,-0.199 -0.303,-0.323 -0.52,-0.29c-0.199,0.031 -0.36,0.181 -0.405,0.377c-0.098,0.424 0.394,0.753 0.752,0.51c0.187,-0.128 0.261,-0.374 0.178,-0.584Zm-0.006,-0.015l0.001,0.002l0.001,0.002l0.002,0.004c0,0.003 0.001,0.005 0.002,0.007l0.001,0.002c0,0 -0,-0.001 -0,-0.001c-0.001,-0.003 -0.002,-0.005 -0.003,-0.008l-0.003,-0.007c-0.001,-0 -0.001,-0.001 -0.001,-0.001Zm5.961,-4.469l-1.027,-0c-0.27,-0 -0.488,0.218 -0.488,0.488c-0,0.27 0.218,0.489 0.488,0.489l1.027,-0c0.27,-0 0.489,-0.219 0.489,-0.489c0,-0.27 -0.219,-0.488 -0.489,-0.488Zm-6.563,0.488c0,-0.27 -0.219,-0.488 -0.489,-0.488l-1.026,-0c-0.27,-0 -0.489,0.218 -0.489,0.488c-0,0.27 0.219,0.489 0.489,0.489l1.026,-0c0.27,-0 0.489,-0.219 0.489,-0.489Zm8.547,-5.169c-0.425,-0.693 -1.195,-1.124 -2.009,-1.124l-7.917,0c-1.57,0 -2.957,1.057 -3.373,2.57l-0.062,0.224c-0.161,0.584 -0.408,1.586 -0.419,1.629c-0.036,0.146 -0.003,0.3 0.09,0.418c0.093,0.119 0.234,0.188 0.385,0.188l14.833,-0c0.177,-0 0.341,-0.096 0.427,-0.251c0.086,-0.154 0.082,-0.343 -0.01,-0.494l-1.945,-3.16Zm-5.647,-0.147l0,3.074l-4.499,0l-0,-3.064c0.072,-0.006 0.146,-0.01 0.22,-0.01l4.279,0Zm0.978,3.074l-0,-3.074l2.66,0c0.477,0 0.927,0.253 1.177,0.659l1.486,2.415l-5.323,0Zm-7.749,-0.998l0.061,-0.224c0.187,-0.677 0.643,-1.227 1.233,-1.547l0,2.769l-1.555,0c0.082,-0.325 0.183,-0.716 0.261,-0.998Z'
  },
  {
    name: 'Heat',
    svg: 'M15.469,23.524l-0,-14.618c-0,-0.259 -0.21,-0.469 -0.469,-0.469c-0.259,0 -0.469,0.21 -0.469,0.469l0,14.618c-0.544,0.194 -0.937,0.708 -0.937,1.32c-0,0.776 0.63,1.406 1.406,1.406c0.776,-0 1.406,-0.63 1.406,-1.406c0,-0.612 -0.393,-1.127 -0.937,-1.32Zm-0.469,1.788c-0.259,0 -0.469,-0.21 -0.469,-0.468c0,-0.259 0.21,-0.469 0.469,-0.469c0.259,-0 0.469,0.21 0.469,0.469c-0,0.258 -0.21,0.468 -0.469,0.468Zm3.281,-4.446l0,-18.054c0,-1.553 -1.259,-2.812 -2.812,-2.812l-0.938,0c-1.553,0 -2.812,1.259 -2.812,2.813l-0,18.053c-1.145,0.946 -1.875,2.376 -1.875,3.978c-0,2.848 2.308,5.156 5.156,5.156c2.848,-0 5.156,-2.308 5.156,-5.156c0,-1.602 -0.73,-3.032 -1.875,-3.978Zm-3.281,8.196c-2.326,0 -4.219,-1.892 -4.219,-4.218c0,-1.263 0.56,-2.45 1.535,-3.255l0.032,-0.027l0.777,0c0.259,0 0.469,-0.21 0.469,-0.468c-0,-0.259 -0.21,-0.469 -0.469,-0.469l-0.469,-0l0,-1.875l0.469,-0c0.259,-0 0.469,-0.21 0.469,-0.469c-0,-0.259 -0.21,-0.469 -0.469,-0.469l-0.469,0l0,-1.874l0.469,-0c0.259,-0 0.469,-0.21 0.469,-0.469c-0,-0.259 -0.21,-0.469 -0.469,-0.469l-0.469,0l0,-1.875l0.469,0c0.259,0 0.469,-0.21 0.469,-0.469c-0,-0.258 -0.21,-0.468 -0.469,-0.468l-0.469,-0l0,-1.875l0.469,-0c0.259,-0 0.469,-0.21 0.469,-0.469c-0,-0.259 -0.21,-0.469 -0.469,-0.469l-0.469,0l0,-1.875l0.469,0c0.259,0 0.469,-0.21 0.469,-0.469c-0,-0.258 -0.21,-0.468 -0.469,-0.468l-0.469,-0l0,-1.875l0.469,-0c0.259,-0 0.469,-0.21 0.469,-0.469c-0,-0.259 -0.21,-0.469 -0.469,-0.469l-0.469,0l0,-0.937c0,-1.035 0.841,-1.875 1.875,-1.875l0.938,-0c1.034,-0 1.875,0.84 1.875,1.875l-0,18.494l0.34,0.282c0.975,0.805 1.535,1.992 1.535,3.255c-0,2.326 -1.893,4.218 -4.219,4.218Z'
  },
  {
    name: 'Electrical socket',
    svg: 'M16.811,8.997l-2.318,-0.937l-2.154,5.332c-0.963,2.384 -0.188,5.071 1.717,6.622c-1.437,3.427 -4.81,5.674 -8.533,5.673l-0,1.5c4.25,0.001 8.107,-2.519 9.825,-6.382c0.056,0.025 0.112,0.049 0.169,0.072c2.924,1.182 6.303,-0.253 7.485,-3.177c-0,-0 2.154,-5.332 2.154,-5.332l-2.318,-0.936l1.686,-4.173l-1.391,-0.561l-1.686,4.172l-3.245,-1.311l1.686,-4.173l-1.391,-0.562l-1.686,4.173Zm-1.489,1.016l7.881,3.184c0,0 -1.592,3.941 -1.592,3.941c-0.873,2.161 -3.371,3.222 -5.533,2.348c-2.161,-0.873 -3.221,-3.371 -2.348,-5.532l1.592,-3.941Z'
  },
  {
    name: 'Battery',
    svg: 'M28,22.144l-0,-3.268l2,-0l-0,-6l-2,-0l-0,-3.268c-0,-0.955 -0.777,-1.732 -1.732,-1.732l-24.536,0c-0.955,0 -1.732,0.777 -1.732,1.732l0,12.535c0,0.956 0.777,1.733 1.732,1.733l24.536,-0c0.955,-0 1.732,-0.777 1.732,-1.732Zm-26.268,0.732c-0.404,-0 -0.732,-0.329 -0.732,-0.732l0,-12.536c0,-0.403 0.328,-0.732 0.732,-0.732l24.536,-0c0.404,-0 0.732,0.328 0.732,0.732l-0,12.536c-0,0.403 -0.328,0.732 -0.732,0.732l-24.536,-0Zm19.714,-5c0.211,0.01 0.411,-0.106 0.503,-0.303l0.16,-0.39l-0.305,-0.247l-8.804,-5.458l0,2.898l-6.442,0.001c-0.206,-0.011 -0.406,0.1 -0.501,0.29l-0.176,0.397l0.318,0.253l9.301,4.885l0,-2.326l5.946,-0Zm-6.946,0.673l-6.053,-3.172l5.553,-0.001l-0,-2.102l5.814,3.602l-5.314,-0l-0,1.673Zm14.5,-4.673l-0,4l-1,-0l-0,-4l1,-0Z'
  },
  {
    name: 'Control unit',
    svg: 'M25.464,18.79l-12.702,-0l-4.133,4.82l4.156,4.346l12.679,-0c0.839,-0 1.528,-0.69 1.528,-1.528l0,-6.164c-0.028,-0.818 -0.709,-1.475 -1.528,-1.474Zm0,7.638l-12.03,0l-2.742,-2.879l2.772,-3.232l12,0l0,6.111Zm-19.928,-3.414l-0,-13.161c2.215,1.092 6.37,1.436 9.166,1.436c2.795,-0 6.951,-0.344 9.166,-1.436l0,3.903c-0.695,0.626 -3.819,1.627 -9.166,1.627c-2.578,0.064 -5.151,-0.247 -7.639,-0.924l0,1.275c2.5,0.609 5.066,0.907 7.639,0.886c2.643,0 6.974,-0.343 9.166,-1.459l0,2.468l1.528,-0l-0,-9.587c-0,-2.559 -6.722,-3.246 -10.694,-3.246c-3.972,0 -10.694,0.687 -10.694,3.246l-0,14.972c-0,1.528 2.421,2.398 5.217,2.841l-1.871,-1.963c-1.055,-0.305 -1.719,-0.641 -1.818,-0.878Zm7.722,-0.405c-0.419,0 -0.764,0.345 -0.764,0.764c0,0.419 0.345,0.764 0.764,0.764c0.419,-0 0.764,-0.345 0.764,-0.764c-0,-0.419 -0.345,-0.764 -0.764,-0.764Zm-6.195,-1.841c0.692,0.189 1.393,0.339 2.101,0.451l0.924,-1.077c-1.034,-0.125 -2.057,-0.337 -3.055,-0.634l0.03,1.26Zm7.639,-14.444c5.461,-0 8.807,1.1 9.166,1.718c-0.351,0.619 -3.697,1.719 -9.166,1.719c-5.469,0 -8.93,-1.138 -9.166,-1.665c0.236,-0.627 3.597,-1.772 9.166,-1.772Z'
  },
  {
    name: 'Home',
    svg: 'M 29.742897,13.68903 25.280524,9.5456204 V 2.7576465 H 20.140133 V 4.773067 L 14.999744,0 0.25710357,13.68903 c -0.20767165,0.193267 -0.22000881,0.518633 -0.0267229,0.726804 0.19276426,0.207661 0.51815142,0.21948 0.72685117,0.02672 L 2.66332,12.858387 V 30 h 8.224625 8.224625 8.224624 V 12.857871 l 1.706096,1.584169 c 0.0987,0.09201 0.224635,0.13724 0.350059,0.13724 0.138275,0 0.275526,-0.055 0.376276,-0.16397 0.193278,-0.20766 0.180941,-0.533025 -0.02672,-0.726291 z M 21.168212,3.78566 h 3.084234 V 8.5911098 L 21.168212,5.7275776 Z M 11.915509,28.971994 V 18.145469 c 0,-0.265744 0.215896,-0.481624 0.481655,-0.481624 h 5.205159 c 0.265759,0 0.481655,0.215881 0.481655,0.481624 v 10.826525 z m 14.393094,0 H 19.112056 V 18.145469 c 0,-0.832692 -0.67699,-1.509639 -1.509733,-1.509639 h -5.205159 c -0.832743,0 -1.509733,0.676947 -1.509733,1.509639 V 28.971994 H 3.6908844 V 11.90337 L 14.999744,1.4027246 l 7.340477,6.8157302 2.940303,2.7298902 v 0 l 1.028079,0.954511 z'
  },
];

function calculateDirection(value) {
  if (value > 0) {
    return 'out';
  }
  if (value < 0) {
    return 'in';
  }
  return 'off';
}


export default {
  name: 'EnergoWidget',
  computed: {
    ...mapGetters([
      'getEnergoWidgetObject',
    ]),
    devices() {

      const calculateValues = (device, averagePower) => {

        const totalAmount = Math.abs(device.currentPVE) + Math.abs(device.currentGrid) + Math.abs(device.currentStorage);

        if (!totalAmount) {
          return {
            text: '0 kW',
            source: [
              {
                color: 'orange',
                value: 100,
              },
              {
                color: 'red',
                value: 0,
              },
              {
                color: 'green',
                value: 0,
              },
            ],
            line: 'off',
          };
        }

        const total = device.currentPVE + device.currentGrid + device.currentStorage;

        const orange = Math.round(Math.abs(device.currentStorage) / totalAmount * 100);
        const green = Math.round(Math.abs(device.currentPVE) / totalAmount * 100);
        const red = Math.round(Math.abs(device.currentGrid) / totalAmount * 100);

        let stroke = 1;
        if (totalAmount / averagePower * 100 > 100) {
          stroke = 2;
        }
        if (totalAmount / averagePower * 100 > 200) {
          stroke = 3;
        }
        if (totalAmount / averagePower * 100 > 400) {
          stroke = 4;
        }

        let lineColor = 'orange';
        if (green > orange) {
          lineColor = 'green';
        } else if (red > orange) {
          lineColor = 'red';
        }
        if (red > green) {
          lineColor = 'red';
        }

        return {
          text: `${Math.round(total * 100) / 100} kW`,
          source: [
            {
              color: 'orange',
              value: orange,
            },
            {
              color: 'red',
              value: red,
            },
            {
              color: 'green',
              value: green,
            },
          ],
          lineMod: {
            color: lineColor,
            strokewidth: stroke,
          },
          line: calculateDirection(device.deviceType.value === 2 ? -total : total),
        };
      };

      const averagePower = this.getEnergoWidgetObject.reduce((sum, device) => sum + Math.abs(device.currentPVE) + Math.abs(device.currentGrid) + Math.abs(device.currentStorage), 0) / 10;

      return {
        devices: this.getEnergoWidgetObject.filter(
          item => item.deviceType.value !== 0,
        ).sort((a, b) => (a.deviceType.value < b.deviceType.value) ? 1 : -1).map(item => ({
          ...DEVICE_TYPES[item.deviceType.value],
          ...calculateValues(item, averagePower),
        })),
      };
    },
  },
  methods: {
    displayEnergyWidgetSVG(data) {
      const xmlns = 'http://www.w3.org/2000/svg';
      const svgWidth = 600;
      const svgHeight = 600;
      const sateliteNumber = data.devices.length;
      if (screen.width < 400) {
        var radius = 80; // kolečko měřáku widgetu
        var textFontSize = '20px';
        var lineHeight = 21;
        var scaleIcon='scale(1.7)';
        var translateIcon='translate( calc(50% - 49px), 6% )';
        var satelitePathRadius = (( svgWidth ) / 100 ) * 36; // svg width a z toho procento
      } else {
        var radius = 65; // kolečko měřáku widgetu
        console.log("65");
        var textFontSize = '16px';
        var lineHeight = 17;
        var scaleIcon='scale(1.2)';
        var translateIcon='translate( calc(50% - 27px), 12% )';
        var satelitePathRadius =   (( svgWidth ) / 100 ) * 37; // svg width a z toho procento
      }
      const border = 3 // rámeček znázorňující složení energií
      var angle = (360 / (sateliteNumber - 1)); // úhel mezi jednotlivými satelity
      var angles = []; // pole pro spočítané souřadnice
      const circleMax = radius + border // vnitřní kolečko
      const circleMin = radius - border // vnejší kolečko
      const svg = document.createElementNS(xmlns, "svg");
      // svg.setAttributeNS(null, 'height', svgHeight);
      svg.setAttributeNS(null, 'width', '100%');
      svg.setAttributeNS(null, 'preserveAspectRatio', "none meet");
      svg.setAttributeNS(null, 'viewBox', "0 0 " + svgWidth + " " + svgHeight);
      svg.setAttributeNS(null, 'x', 0);
      svg.setAttributeNS(null, 'y', 0);
      for (var i = 0; i < sateliteNumber; i++) {
        var x = Math.sin(i * angle * Math.PI / 180) * satelitePathRadius + 300;
        var y = Math.cos(i * angle * Math.PI / 180) * satelitePathRadius + 300;
        angles.push({'x': x, 'y': y})
      }
      var batteryCenterX = (((svgWidth / 2) / svgWidth) * 100) - ((circleMax / svgWidth) * 100)
      var batteryCenterY = (((svgHeight / 2) / svgHeight) * 100) - ((circleMax / svgHeight) * 100)
      var touchBatteryProcX = (svgWidth / (2 * svgWidth)) * 100
      var touchBatteryProcY = (svgHeight / (2 * svgHeight)) * 100
      for (var i = 0; i < sateliteNumber; i++) {
        var g = document.createElementNS(xmlns, 'g');
        g.setAttributeNS(null, 'id', 'graphic' + i);
        svg.appendChild(g);

        var element = document.createElementNS(xmlns, 'svg');
        element.setAttributeNS(null, 'width', circleMax * 2);
        element.setAttributeNS(null, 'height', circleMax * 2);
        element.setAttributeNS(null, 'class', 'element');
        if (i < sateliteNumber - 1) {
          element.setAttributeNS(null, 'x', angles[i].x - circleMax);
          element.setAttributeNS(null, 'y', angles[i].y - circleMax);
        } else { // pro poslední položku, která je baterií či řídící jednotkou a proto ve středu widgetu
          element.setAttributeNS(null, 'x', batteryCenterX + '%');
          element.setAttributeNS(null, 'y', batteryCenterY + '%');
        }
        element.setAttributeNS(null, 'style', 'filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .3));');
        g.appendChild(element);
        var nextStart = 0
        var rotate = 0
        for (var a = 0; a < data.devices[i].source.length; a++) {
          if (data.devices[i].line == "off") {
            var color = "gray";
          } else {
            var color = data.devices[i].source[a].color
          }
          var rawValue = data.devices[i].source[a].value
          var value = 3.6 * rawValue + nextStart;
          if (value > 0) {
            nextStart = value;
            var ring = document.createElementNS(xmlns, 'circle');
            ring.setAttributeNS(null, 'cx', '50%');
            ring.setAttributeNS(null, 'cy', '50%');
            ring.setAttributeNS(null, 'r', radius / 2);
            ring.setAttributeNS(null, 'fill', "transparent");
            ring.setAttributeNS(null, 'stroke', color);
            ring.setAttributeNS(null, 'stroke-width', circleMax);
            ring.setAttributeNS(null, 'data-percentage', rawValue);
            ring.setAttributeNS(null, 'style', 'transform-origin: center; transform: rotate(' + rotate + 'deg)')
            const percentage = rawValue;
            const circumference = Math.PI * (radius / 2) * 2;
            const strokeDash = Math.round((percentage * circumference) / 100);
            const strokeDashArray = `${strokeDash} ${circumference}`;
            ring.setAttribute('stroke-dasharray', strokeDashArray);
            element.appendChild(ring);
            var rotate = 3.6 * rawValue + rotate
          }
        }
        var circle = document.createElementNS(xmlns, 'circle');
        circle.setAttributeNS(null, 'id', 'satelite' + i);
        circle.setAttributeNS(null, 'cx', '50%');
        circle.setAttributeNS(null, 'cy', '50%');
        circle.setAttributeNS(null, 'r', circleMin);
        circle.setAttributeNS(null, 'style', 'stroke-width: 1px;  fill: rgba(255, 255, 255, 1);');
        circle.setAttributeNS(null, 'data-number', i);
        element.appendChild(circle);
        var text = document.createElementNS(xmlns, 'text');
        text.setAttributeNS(null, 'id', 'text' + i);
        text.setAttributeNS(null, 'x', '50%');
        text.setAttributeNS(null, 'y', '60%');
        text.setAttributeNS(null, 'width', radius * 2);
        text.setAttributeNS(null, 'fill', 'black');
        var word = data.devices[i].text.split(" ") // slova rozdělit dle mezer – pokud má být string nerozdělen, použít tvrdou mezeru
        var words = word.length
        for (var n = 0; n < words; n++) {
          const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
          tspan.textContent = word[n];
          const translate = 'translate( calc(50%), -12% ) ';
          tspan.setAttributeNS(null, 'text-anchor', 'middle');
          tspan.setAttributeNS(null, 'x', '50%');
          tspan.setAttributeNS(null, 'y', '57%');
          tspan.setAttributeNS(null, 'dy', n * lineHeight);
          tspan.setAttributeNS(null, 'letter-spacing', '-0.25');
          tspan.setAttributeNS(null, 'font-size', textFontSize);
          tspan.setAttributeNS(null, 'style', 'transform:' + translate );
          text.appendChild(tspan);
        }
        element.appendChild(text);
        if (i < sateliteNumber - 1) { // pokud je vykreslovaná položka jiná, než poslední = baterie/řídící jednotka
          var line = document.createElementNS(xmlns, 'line');
          line.setAttributeNS(null, 'id', 'line' + i);
          line.setAttributeNS(null, 'class', 'line ' + data.devices[i].line);
          if (typeof data.devices[i].lineMod === 'undefined') {
            line.setAttributeNS(null, 'stroke-dasharray', 4)
            line.setAttributeNS(null, 'stroke', 'blue')
            line.setAttributeNS(null, 'stroke-width', 1)
          } else {
            line.setAttributeNS(null, 'stroke', data.devices[i].lineMod.color)
            line.setAttributeNS(null, 'stroke-width', data.devices[i].lineMod.strokewidth)
          }
          if (data.devices[i].line === 'in') { // pokud je směr animace do baterie, vykreslí se čára
            line.setAttributeNS(null, 'x1', '50%');
            line.setAttributeNS(null, 'y1', '50%');
            line.setAttributeNS(null, 'x2', angles[i].x);
            line.setAttributeNS(null, 'y2', angles[i].y);
          } else { // jinak je vykreslena čára opačně, aby animace směřovala ven
            line.setAttributeNS(null, 'x2', '50%');
            line.setAttributeNS(null, 'y2', '50%');
            line.setAttributeNS(null, 'x1', angles[i].x);
            line.setAttributeNS(null, 'y1', angles[i].y);
          }
          svg.prepend(line);
        }
        if (data.devices[i].icon !== null) {
          let myIcon = DEVICE_ICONS.find(el => el.name === data.devices[i].icon);
          const icon = document.createElementNS(xmlns, 'path');
					const	iconX = x;
          const iconY = y;
          const transform = scaleIcon + ' ' + translateIcon
          icon.setAttributeNS(null, 'd', myIcon["svg"]);
          icon.setAttributeNS(null, 'id', 'icon' + i);
          icon.setAttributeNS(null, 'style', 'fill:#030104; transform:' + transform );
          element.appendChild(icon);
        }
        var touch = document.createElementNS(xmlns, 'circle'); // klikací transparentní kolečko přes celý obsah satelitu
        touch.setAttributeNS(null, 'id', 'touch' + i);
        touch.setAttributeNS(null, 'class', 'touch');
        touch.setAttributeNS(null, 'data-detail', data.devices[i].detail);
        if (i < sateliteNumber - 1) {
          touch.setAttributeNS(null, 'cx', angles[i].x)
          touch.setAttributeNS(null, 'cy', angles[i].y)
        } else {
          touch.setAttributeNS(null, 'cx', touchBatteryProcX + '%');
          touch.setAttributeNS(null, 'cy', touchBatteryProcY + '%');
        }
        touch.setAttributeNS(null, 'r', circleMax);
        touch.setAttributeNS(null, 'style', 'stroke-width: ' + border + 'px;  fill: transparent;');
        touch.setAttributeNS(null, 'data-number', i);
        touch.setAttribute("v-on:click", `this.handleDeviceClick(${data.devices[i].id})`);
        svg.appendChild(touch);
      }
      const oSerializer = new XMLSerializer();
      return oSerializer.serializeToString(svg);
    },
    renderEnergyWidget() {
      const widgetSvgStr = this.displayEnergyWidgetSVG(this.devices);
      const Profile = Vue.extend({
        template: `<div id='energy-widget'>${widgetSvgStr}</div>`,
      });
      new Profile().$mount("#energy-widget");
    },
    handleDeviceClick(id) {
      alert(`clicked ${id}`);
    },
  },
  mounted() {
    window["handleDeviceClick"] = (id) => {
      this.handleDeviceClick(id);
    };
    this.renderEnergyWidget();
  },
  watch: {
    getEnergoWidgetObject() {
      this.renderEnergyWidget();
    },
  },
};
</script>

<style lang="scss" scoped>

.widget-inner {
  display: grid;
  justify-items: stretch;
  grid-template-rows: minmax(0px, auto);
}

.top {
  text-align: center;
}

.bottom {
  padding: 10px 10px;
}

</style>
